import { type ItemPosition } from './types';

export const getItemPosition = (index: number, length: number): ItemPosition => {
	if (length === 1) {
		return 'only';
	}

	if (index === 0) {
		return 'first';
	}

	if (index === length - 1) {
		return 'last';
	}

	return 'middle';
};
